import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiLavandierService } from '../../../lib/lib-ngx/web-services/api-lavandier.service';
import { IStorage } from '../../../lib/lib-shared/models/Storage';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'lm-ptl',
  templateUrl: './ptl.component.html',
  styleUrls: ['./ptl.component.scss']
})
export class PtlComponent implements OnInit {
  public storageList: IStorage[] = [];
  public storageForm = this.fb.group({});

  get storageFormGroups(): { [id: string]: FormGroup } {
    return this.storageForm.controls as { [id: string]: FormGroup };
  }

  constructor(
    private apiLavandierService: ApiLavandierService,
    private modalService: NgbModal,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.loadStorageList();
  }

  loadStorageList() {
    this.apiLavandierService
      .getStorageList({})
      .subscribe(storageList => {
        this.storageList = storageList;
        this.buildFormGroups();
      });
  }

  buildFormGroups() {
    this.storageForm = this.fb.group(
      this.storageList.reduce((acc, storage) => {
        acc[storage.id] = this.fb.group({
          weight: [storage.weight, Validators.required],
          disabled: [storage.disabled],
        });
        return acc;
      }, {} as { [id: string]: FormGroup })
    );
  }

  updateAllStorages() {
    const confirmationModal = this.modalService.open(ConfirmationModalComponent, {size: 'lg'});
    confirmationModal.componentInstance.confirmationDesc = 'Voulez-vous vraiment modifier les rangements ?';
    confirmationModal.componentInstance.validateButtonText = 'Confirmer';
    confirmationModal.componentInstance.cancelButtonText = 'Annuler';
    confirmationModal.result
      .then(result => {
        if (result) {
          const storages = Object.entries(this.storageFormGroups)
            .filter(([, group]) => group.dirty)
            .map(([id, group]) => ({
              id: +id,
              weight: group.value.weight,
              disabled: group.value.disabled,
            }));
          this.apiLavandierService
            .putStorage({storageList: storages})
            .subscribe(() => {
              this.loadStorageList();
            });
        }
      })
      .catch(() => {});
  }
}
